export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.client) {
    let lastStableWidth = 0

    const getStableWidth = () => {
      return document.documentElement.clientWidth
    }

    const setZoom = () => {
      const html = document.documentElement
      const width = getStableWidth() || window.innerWidth
      if (width === lastStableWidth && width !== 0) return
      lastStableWidth = width

      let zoom = 1
      if (width >= 768 && width < 1440) {
        zoom = width / 1920
      }

      html.style.zoom = zoom.toString()
      html.classList.add('zoom-ready')
    }

    document.documentElement.classList.remove('zoom-ready')
    setZoom()

    nuxtApp.hook('app:mounted', () => {
      requestAnimationFrame(setZoom)
    })

    window.addEventListener('resize', setZoom)

    return {
      provide: {
        refreshZoom: setZoom,
      },
    }
  }

  return {
    provide: {
      refreshZoom: () => {},
    },
  }
})
